// removed by extract-text-webpack-plugin
module.exports = {"purple":"#9800ff","content":"app__content___24z2e"};


//////////////////
// WEBPACK FOOTER
// ./src/views/App/app.css
// module id = 172
// module chunks = 0